<script>
import headerStrom from "@/assets/header_strom.jpg";
import {mapGetters} from "vuex";
import RightColumnGroup from "@/components/layout/RightColumnGroup.vue";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";

export default {
  name: "StromView",
  components: {Breadcrumbs, RightColumnGroup},
  data: () => ({
    header: headerStrom,
  }),
  computed: {
    hideServices() {
      return this.userCommuneName === "Brüggen" || this.userCommuneName === "Schwalmtal";
    },
    text() {
      if(this.hideServices) {
        return `
        <p class="font-weight-bold">Energie für die Kommunen – partnerschaftlich mit der NEW </p>
        <p>
          Zuverlässigkeit, Effizienz, Klimaschutz, Digitalisierung und Innovationen im Energiesektor - unter diesen Prämissen liefert die NEW Niederrhein Energie und Wasser GmbH servicestark Strom für die Kommunen. Außerdem erbringt sie ergänzend viele weitere energienahe Dienstleistungen.<br>
          <br>
          Als regionaler Strom- und Erdgaslieferant ist die NEW Niederrhein Energie und Wasser GmbH prämiert: zum einen als “Top-Lokalversorger 2021”, zum anderen für ihren exzellenten Kundenservice mit dem Zertifikat Service Excellence des TÜV SÜD. <br>
          <br>
          Kund:innen können aus verschiedenen Tarifen wählen. Sie unterscheiden sich zum Beispiel in ihrer Ökobilanz, ihrer Laufzeit und dem Umfang des Kundenservice. Für Kommunen bietet die NEW Niederrhein Energie und Wasser GmbH maßgeschneiderte Energielieferungen an oder nimmt an deren Ausschreibungen teil.<br>
          <br>
          Die Bandbreite der Dienstleistungen reicht vom Energieaudit über das Pachten einer Photovoltaikanlage bis hin zu Mobilitätsangeboten. <br>
          <br>
          An sechs persönlichen Beratungsstellen, telefonisch über die Hotline und digital rund um die Uhr ist die NEW Niederrhein Energie und Wasser GmbH für ihre Kund:innen erreichbar - ein ausgezeichneter partnerschaftlicher Service!
        </p>

        `
      }

      return `
      <p class="font-weight-bold">Energieversorgung und Netzbetrieb aus einer Hand</p>
        <p>
          Eine sichere, effiziente und zukunftsorientierte Energieversorgung ist die Grundlage
          für eine starke Region. Die Unternehmen der NEW-Gruppe sorgen gemeinsam dafür, dass
          Kommunen, Unternehmen und Bürger:innen zuverlässig mit Energie versorgt werden und von
          modernen Energiedienstleistungen profitieren.<br>
          <br>
          Die NEW Niederrhein Energie und Wasser GmbH liefert Strom und Erdgas und bietet
          darüber hinaus zahlreiche energienahe Dienstleistungen an. Das Angebot reicht von
          maßgeschneiderten Energielieferungen für Kommunen über Energieaudits und
          Photovoltaiklösungen bis hin zu modernen Mobilitätsangeboten. Dabei stehen Klimaschutz,
          Digitalisierung, Versorgungssicherheit und innovative Energielösungen im Fokus.<br>
          <br>
          Als regionaler Verteilnetzbetreiber sorgt die NEW Netz GmbH für den sicheren Betrieb und
          die kontinuierliche Weiterentwicklung der Stromnetze. Sie plant, baut und betreibt die
          Netzinfrastruktur und entwickelt diese im Sinne der Energiewende zu intelligenten Netzen
          („Smart Grids“) weiter. Darüber hinaus erstellt sie Netzanschlüsse für Verbrauchs- und
          Erzeugungsanlagen und übernimmt als grundzuständiger Messstellenbetreiber den Einbau und
          Betrieb moderner Messeinrichtungen sowie intelligenter Messsysteme.

          Kommunen profitieren von einer starken regionalen Präsenz und kurzen Wegen. Die
          Mitarbeiter:innen der NEW sind vor Ort erreichbar und stehen bei Fragen rund um
          Energieversorgung, Netzanschlüsse und Infrastrukturprojekte beratend zur Seite.
          Ergänzt wird das Angebot durch digitale Services, Hotlines und persönliche
          Ansprechpartner:innen.<br>
          <br>
          Ein besonderes Serviceangebot stellt das <a href="https://gis.geo.new.de" target="_blank">View-Portal</a> der NEW Netz GmbH dar.
          Dort werden die im Konzessionsgebiet vorhandenen Ver- und Entsorgungsleitungen digital
          dargestellt. Kommunen können Karten und Daten schnell und unkompliziert abrufen sowie
          über einen WMS-Dienst in eigene GIS-Anwendungen integrieren.
          Dadurch lassen sich die Leitungsdaten direkt mit kommunalen Planungen und
          Projekten verknüpfen.
        </p>
      `
    },
    ...mapGetters('user', ['userCommunePartner', 'userCommuneRegionalLeader', "userCommuneName", "getDashboardCommunePartners"]),
    sidebarConfig() {
      return {
        showRegionalLeiter: false,
        personsInCharge: this.getDashboardCommunePartners,
        interestingLinks: [
          { id: 0, title: "Günstiger Energieversorger für Strom & Gas | NEW Energie ", link: "https://www.new-energie.de/" },
          !this.hideServices ? { id: 1, title: "NEW Netz - Ihr Parner für sichere Energieversorgung", link: "https://www.new-netz.de/" } : null
        ].filter(link => link !== null)
      }
    }
  }
}
</script>

<template>
  <div class="strom-view min-height-100">
    <v-img
      :src="header"
      aspect-ratio="2.1333"
      max-height="450px"
      class="strom-header"
    >
      <span
        class="custom-header-text new-font-bold white--text"
        style="position: absolute; bottom: 20px; left: 35px;"
      >
        Strom
      </span>
    </v-img>
    <v-row no-gutters class="strom-content">
      <v-col cols="12" sm="8" class="new-wrapper px-10 py-4">
        <breadcrumbs />
        <div v-html="text"></div>
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="contact_container pl-4"
      >
        <RightColumnGroup
            :communePartner="userCommunePartner"
            :communeRegionalLeader="userCommuneRegionalLeader"
            :contentObject="sidebarConfig"
        />
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.strom-view {
  display: flex;
  flex-direction: column;
}

.strom-header {
  flex-shrink: 0;
}

.strom-content {
  flex: 1;
}
</style>
